import React from 'react';
import PropTypes from 'prop-types';

export default function Alignment(props) {
    return (
        <>
            <div className="analysis-type-info-label">Alignment:</div>
            <div>{props.preprocessingOnlyAlignment ? 'On' : 'Off'}</div>
        </>
    );
}

Alignment.propTypes = {
    preprocessingOnlyAlignment: PropTypes.bool.isRequired,
};
